import React from 'react';

import { useMediaQuery } from 'react-responsive';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';

import { ApiObject, Country, PopularSchool } from 'app/types';

import Text from 'common/components/Text/Text';

import { navigateTop } from 'common/utils';
import { detailUrl } from 'common/utils/conversions';

import styles from './Tabs.module.scss';

interface CompProps {
  country?: ApiObject<Country>;
}

const Schools = ({ country }: CompProps): React.ReactElement => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const navigate = useNavigate();

  return (
    <div className={styles.schoolsContainer}>
      <div className={styles.section}>
        <Text size={isMobile ? 15 : 24} weight={700}>
          Popular Schools in this country
        </Text>
      </div>
      <div className={styles.section}>
        {country?.data.popular_schools &&
          country.data.popular_schools.map((school: PopularSchool) => (
            <div
              className={styles.schoolCard}
              key={school.id}
              onClick={() =>
                isMobile ? navigate(detailUrl('schools', school.id, school.name)) : null
              }
            >
              <div className={styles.logo}>
                <img src={school.logo} alt={`Logo of ${school.name}`} className={styles.logo} />
              </div>
              <div className={styles.info}>
                <div className={styles.name}>{school.name}</div>
                <div className={styles.location}>
                  {!isMobile && <i className="bi bi-geo-alt"></i>}
                  {school.city}, {school.country}
                </div>
              </div>
              {!isMobile && (
                <div className={`d-flex flex-row justify-content-end ${styles.endContainer}`}>
                  <Link
                    to={detailUrl('schools', school.id, school.name)}
                    onClick={() => navigateTop()}
                  >
                    <div className={`d-flex flex-row justify-content-end ${styles.endRow}`}>
                      <p>View more</p>
                      <i className="bi bi-chevron-right"></i>
                    </div>
                  </Link>
                </div>
              )}
            </div>
          ))}
      </div>
    </div>
  );
};

export default Schools;
